// @spec DHB-STR-040
'use client';

import { createFileRoute } from '@tanstack/react-router';

import { ValidationErrorsPage } from '@/features/datahub/components/ValidationErrorsPage';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/datahub/validation-errors')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.validationErrors'),
  }),
  component: ValidationErrorsPage,
});
